import { CmsContentPage, HotelsPage, HotelSearchResultsSlot } from '@honeycomb/ui';
import {
    getPageAndGlobalProps,
    GetFacadeContentQuery,
    GlobalQuery,
    FunnelQueryParamsEnum,
    getFacadeContentQuery,
} from '@honeycomb/data';
import { GetServerSidePropsContext } from 'next';

// This path is used for both a landing page and the in-funnel hotel search results page
// Original plan was to handle this via rewrites but that's not compatible with our current routing approach
export default function Hotels(props: GetFacadeContentQuery | GlobalQuery): React.JSX.Element {
    if ('getPage' in props) {
        const { getPage } = props;
        return <CmsContentPage {...{ getPage }} />;
    }

    return <HotelsPage hotelSearchResultsSlot={HotelSearchResultsSlot} />;
}

export async function getServerSideProps(context: GetServerSidePropsContext) {
    const isFunnelSRP = Object.values(FunnelQueryParamsEnum).some((param) =>
        Object.keys(context.query).includes(param)
    );
    if (isFunnelSRP) {
        return getPageAndGlobalProps(context as GetServerSidePropsContext);
    }
    return getPageAndGlobalProps<GetFacadeContentQuery, GetServerSidePropsContext>(
        context,
        getFacadeContentQuery('hotels', [], context.query?.isPreview)
    );
}
